<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total Orders"
                                type="gradient-red"
                                :sub-title="Orders.length"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="New Orders"
                                type="gradient-orange"
                                :sub-title="newOrders.length"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="InTransit"
                                type="gradient-green"
                                :sub-title="inTransit.length"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0">
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Cancelled"
                                type="gradient-info"
                                :sub-title="cancelledOrders.length"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-12">
                                    <h4 class="font-weight-bold text-primary">Shopping Orders</h4>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-5">
                            <vue-good-table
                                    :line-numbers="true"
                                    :columns="columns"
                                    :rows="Orders"
                                    :pagination-options="{
                                       enabled: true,
                                       mode: 'pages',
                                       perPage: 10
                                     }"
                                    :search-options="{
                                    enabled: true,
                                    placeholder: 'Search this table',
                                  }">
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'created'">
                                        <small>{{moment(props.row.created_at).format('MMMM Do YYYY, h:mm:ss a')}}</small>
                                    </span>
                                    <span v-else-if="props.column.field == 'statu'">
                    <span v-if="props.row.status == 0" class="badge badge-primary">new</span>
                    <span v-if="props.row.status == 1" class="badge badge-success">assigned</span>
                </span>
                                    <span v-else-if="props.column.field == 'action'">
                    <router-link :to="{path: '/shoppingOrderInfo/' + props.row.orderNo}">
                        <button class="btn btn-success btn-sm"><i class="fa fa-eye"></i></button>
                    </router-link>
                </span>
                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>
                            </vue-good-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    var moment = require('moment');
    export default {
        name: 'ShoppingOrders',
        components: {},
        data() {
            return {
                moment,
                columns: [
                    {
                        label: 'Order#',
                        field: 'orderNo',
                    },
                    {
                        label: 'Date',
                        field: 'created',
                    },
                    {
                        label: 'County',
                        field: 'county',
                    },
                    {
                        label: 'Cust. Name',
                        field: 'customer.name',
                    },
                    {
                        label: 'Status',
                        field: 'status'
                    },
                    {
                        label: 'Action',
                        field: 'action'
                    }
                ],
            }
        },
        computed: {
            cancelledOrders(){
                return this.$store.state.orders.filter(m => m.status === 'cancelled')
            },
            inTransit() {
                return this.$store.state.orders.filter(m => m.status === 'in-transit')
            },
            newOrders() {
                return this.$store.state.orders.filter(m => m.status === 'pending')
            },
            Orders() {
                return this.$store.state.orders;
            }
        },
        methods: {
            getAllOrders() {
                this.$store.dispatch('retrieve_orders_admin');
            }
        },
        created() {
            this.getAllOrders();
        }
    };
</script>
<style></style>
